<template>
  <div v-loading.fullscreen="loading" :element-loading-text="loadingText" element-loading-spinner="el-icon-loading">
    <nav-default></nav-default>
    <div class="container">
      <b-row class="mt-3 mb-4">
        <b-col lg="4"></b-col>
        <b-col lg="4">
          <h3>Email Verification Required</h3>
          <p>Verification link has been sent to {{verifyEmail}}</p>
          <p>Please verify your email and proceed to log in</p>
          <md-button @click="navigateToLogin" class="md-primary">Log In</md-button>
        </b-col>
      </b-row>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'Login',
    data() {
      return {
        verifyEmail: '',
        loadingText: '',
        loading: false
      }
    },
    created() {
      this.verifyEmail = this.$route.query.email
    },
    methods:{
      navigateToLogin(){
        this.$router.push({
          name: 'login'
        })
      }
    }
  }
</script>
<style scoped>
  .line {
    display: inline-block;
    vertical-align: middle;
    zoom: 1;
    width: 100%;
    border: 1px solid #ededed
  }

  .text-info{
      color: grey;
      font-size: 12px;
  }

</style>



// WEBPACK FOOTER //
// src/components/RegVerify.vue